import { render, staticRenderFns } from "./thumbnail-image.vue?vue&type=template&id=7772d358&scoped=true&lang=pug&"
import script from "./thumbnail-image.vue?vue&type=script&lang=coffee&"
export * from "./thumbnail-image.vue?vue&type=script&lang=coffee&"
import style0 from "./thumbnail-image.vue?vue&type=style&index=0&id=7772d358&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7772d358",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShopifyVisual: require('/opt/build/repo/library/components/globals/shopify-visual.coffee').default})
